module.exports = __webpack_public_path__ + "img/mamma-mia-here-we-go-again.3ac1ba06.jpg";